<div *ngIf="account" class="user" (clickOutside)="closeMenu()">
    <button class="button button--primary" type="button" (click)="toggleMenu()">
        <svg class="user-icon icon kd-icon--m kd-icon--button" kdSldsIcon="user"></svg>
        <span class="user-name">{{account.email}}</span>
    </button>

    <div class="menu" [ngClass]="{
        'menu--open': menuOpen
    }">
        <a *ngIf="canEdit()" class="button button--menu" [href]="page.raw_content" target="_blank">
            <svg class="icon kd-icon--s kd-icon--button kd-icon--button-left" kdSldsIcon="edit"></svg>
            Edit in Quip
        </a>

        <a *ngIf="isQuip()" class="button button--menu" (click)="refresh()">
            <svg class="icon kd-icon--s kd-icon--button kd-icon--button-left" kdSldsIcon="refresh"></svg>
            Refresh Cache
        </a>

        <a *ngIf="account.is_staff" class="button button--menu" [href]="adminUrl" target="_blank">
            <svg class="icon kd-icon--s kd-icon--button kd-icon--button-left" kdSldsIcon="settings"></svg>
            Administration
        </a>

        <a class="button button--menu" (click)="openCredentials()">
            <svg class="icon kd-icon--s kd-icon--button kd-icon--button-left" kdSldsIcon="merge_field"></svg>
            Manage Credentials
        </a>

        <a class="button button--menu" type="button" (click)="logout()">
            <svg class="icon kd-icon--s kd-icon--button kd-icon--button-left" kdSldsIcon="logout"></svg>
            Sign out
        </a>
    </div>
</div>

<div *ngIf="!account" class="user">
    <button class="button" type="button" (click)="login()">Sign in</button>
</div>

<kd-credentials-modal></kd-credentials-modal>
